import { CommunityProfile } from "@/components/webview/type/community-profiles";

export enum WebViewAction {
  RouterBack = "RouterBack",
  OpenWebBrowser = "OpenWebBrowser",

  //ATH - [webview]
  StartAthPreview = "StartAthPreview",
  StopAthPreview = "StopAthPreview",

  ShowAthGuidePopup = "ShowAthGuidePopup",

  ShowAthProfileDetail = "ShowAthProfileDetail",
  ShowAthProfileSetting = "ShowAthProfileSetting",

  ShowAthMyProfileDetail = "ShowAthMyProfileDetail",
  ShowAthMyProfileSetting = "ShowAthMyProfileSetting",

  AddAthMyDevice = "AddAthMyDevice",

  //ATH - [app]
  AthMyProfileDeleted = "AthMyProfileDeleted",
  AthProfileApplied = "AthProfileApplied",

  AthPreviewStarted = "AthPreviewStarted",
  AthPreviewStopped = "AthPreviewStopped",

  AthProfileLiked = "AthProfileLiked",
}

export interface WebViewActionPayloadMap {
  [WebViewAction.RouterBack]: string;
  [WebViewAction.OpenWebBrowser]: { url: string };

  //ATH - [webview]
  [WebViewAction.StartAthPreview]: { profile: CommunityProfile };
  [WebViewAction.StopAthPreview]: { profile: CommunityProfile };

  [WebViewAction.ShowAthGuidePopup]: string;
  [WebViewAction.ShowAthProfileDetail]: {
    id: string;
  };
  [WebViewAction.ShowAthProfileSetting]: {
    id: string;
    name: string;
    category: string;
    subCategory: string;
    producer: string;
    sourceUri: string;
  };
  [WebViewAction.ShowAthMyProfileDetail]: {
    myProfileId: string;
  };

  [WebViewAction.ShowAthMyProfileSetting]: {
    id: string;
    name: string;
    category: string;
    subCategory: string;
    producer: string;
    sourceUri: string;
  };
  [WebViewAction.AddAthMyDevice]: {
    id: string;
  };

  //ATH - [app]  *app 은 명명시 동사를 뒤로
  [WebViewAction.AthMyProfileDeleted]: {
    profileId: string;
  };
  [WebViewAction.AthProfileApplied]: {
    profileId: string;
  };

  [WebViewAction.AthPreviewStarted]: { profileId: string };
  [WebViewAction.AthPreviewStopped]: { profileId: string };

  [WebViewAction.AthProfileLiked]: { profileId: string; liked: boolean };
}
